import { spacingMixin } from '@zillow/constellation';
import { css } from 'styled-components';

const getBackgroundColor = ({ backgroundColor, theme }) => {
  switch (backgroundColor) {
    case 'white':
      return css`
        background-color: ${theme.ns().colors.white};
      `;
    case 'grey':
      return css`
        background-color: ${theme.ns().colors.gray400};
      `;
    case 'lightGrey':
      return css`
        background-color: ${theme.ns().colors.gray300};
      `;
    case 'lighterGrey':
      return css`
        background-color: ${theme.ns().colors.gray200};
      `;
    case 'lightestGrey':
      return css`
        background-color: ${theme.ns().colors.gray100};
      `;
    case 'dark':
      return css`
        background-color: #333;
      `;
    case 'primary':
      return css`
        background-color: ${theme.ns().colors.brand};
      `;
    case 'alert':
      return css`
        background-color: ${theme.ns().colors.red400};
      `;
    case 'zrmBackground':
      return css`
        background-color: ${theme.ns().colors.gray100};
      `;
    default:
      return css``;
  }
};

const getBackgroundHoverColor = ({ backgroundHoverColor, theme }) => {
  switch (backgroundHoverColor) {
    case 'white':
      return css`
        :hover {
          background-color: ${theme.ns().colors.white};
        }
      `;
    case 'grey':
      return css`
        :hover {
          background-color: ${theme.ns().colors.gray400};
        }
      `;
    case 'lightGrey':
      return css`
        :hover {
          background-color: ${theme.ns().colors.gray300};
        }
      `;
    case 'lighterGrey':
      return css`
        :hover {
          background-color: ${theme.ns().colors.gray200};
        }
      `;
    case 'lightestGrey':
      return css`
        :hover {
          background-color: ${theme.ns().colors.gray100};
        }
      `;
    case 'dark':
      return css`
        :hover {
          background-color: #333;
        }
      `;
    case 'primary':
      return css`
        :hover {
          background-color: ${theme.ns().colors.brand};
        }
      `;
    case 'alert':
      return css`
        :hover {
          background-color: ${theme.ns().colors.red400};
        }
      `;
    case 'zrmBackground':
      return css`
        :hover {
          background-color: ${theme.ns().colors.gray100};
        }
      `;
    default:
      return css``;
  }
};

const getBorderColor = ({ borderColor, theme }) => {
  switch (borderColor) {
    case 'default':
      return css`
        border-color: ${theme.ns().colors.gray300};
      `;
    case 'dark':
      return css`
        border-color: #333;
      `;
    case 'primary':
      return css`
        border-color: ${theme.ns().colors.brand};
      `;
    default:
      return css`
        border-color: ${theme.ns().colors.gray300};
      `;
  }
};

const getBorderHoverColor = ({ borderHoverColor, theme }) => {
  switch (borderHoverColor) {
    case 'default':
      return css`
        :hover {
          border-color: ${theme.ns().colors.gray300};
        }
      `;
    case 'dark':
      return css`
        :hover {
          border-color: #333;
        }
      `;
    case 'primary':
      return css`
        :hover {
          border-color: ${theme.ns().colors.brand};
        }
      `;
    default:
      return css`
        :hover {
          border-color: ${theme.ns().colors.gray300};
        }
      `;
  }
};

const getBorderWidthTop = ({ borderWidth }) => {
  switch (borderWidth) {
    case 'thin':
      return css`
        border-top-width: 1px;
      `;
    case 'medium':
      return css`
        border-top-width: 2px;
      `;
    case 'thick':
      return css`
        border-top-width: 4px;
      `;
    default:
      return css`
        border-top-width: 1px;
      `;
  }
};

const getBorderWidthRight = ({ borderWidth }) => {
  switch (borderWidth) {
    case 'thin':
      return css`
        border-right-width: 1px;
      `;
    case 'medium':
      return css`
        border-right-width: 2px;
      `;
    case 'thick':
      return css`
        border-right-width: 4px;
      `;
    default:
      return css`
        border-right-width: 1px;
      `;
  }
};

const getBorderWidthBottom = ({ borderWidth }) => {
  switch (borderWidth) {
    case 'thin':
      return css`
        border-bottom-width: 1px;
      `;
    case 'medium':
      return css`
        border-bottom-width: 2px;
      `;
    case 'thick':
      return css`
        border-bottom-width: 4px;
      `;
    default:
      return css`
        border-bottom-width: 1px;
      `;
  }
};

const getBorderWidthLeft = ({ borderWidth }) => {
  switch (borderWidth) {
    case 'thin':
      return css`
        border-left-width: 1px;
      `;
    case 'medium':
      return css`
        border-left-width: 2px;
      `;
    case 'thick':
      return css`
        border-left-width: 4px;
      `;
    default:
      return css`
        border-left-width: 1px;
      `;
  }
};

const getBorderWidthFull = ({ borderWidth }) => {
  switch (borderWidth) {
    case 'thin':
      return css`
        border-width: 1px;
      `;
    case 'medium':
      return css`
        border-width: 2px;
      `;
    case 'thick':
      return css`
        border-width: 4px;
      `;
    default:
      return css`
        border-width: 1px;
      `;
  }
};

const getBorderRounded = () => css`
  border-radius: 3px;
`;

const getBorderStyle = ({ borderStyle }) => {
  switch (borderStyle) {
    case 'solid':
      return css`
        border-style: solid;
      `;
    case 'dashed':
      return css`
        border-style: dashed;
      `;
    case 'dotted':
      return css`
        border-style: dotted;
      `;
    default:
      return css`
        border-style: solid;
      `;
  }
};

export default (props) =>
  props.theme &&
  props.theme.ns &&
  css`
    border-width: 0;
    ${getBackgroundColor}
    ${getBackgroundHoverColor}
        ${getBorderColor}
        ${getBorderHoverColor}
        ${props.borderTop && getBorderWidthTop}
        ${props.borderRight && getBorderWidthRight}
        ${props.borderBottom && getBorderWidthBottom}
        ${props.borderLeft && getBorderWidthLeft} 
        ${props.borderFull && getBorderWidthFull}
        ${props.borderRounded && getBorderRounded}
        ${getBorderStyle}
        ${spacingMixin}
  `;
